module.exports = __webpack_public_path__ + "static/placeholder-img-a6174ad5445f2c18216adbef8939769c.jpg";